import { getChallengesDiff } from '@/src/types/Challenge';
import { DiffChange, diffObjects } from '@/src/types/Diff';
import {
  BackupChallengeConfig,
  CollaborationOptions,
  EventBase,
  EventConfiguration,
  EventPermission,
  JamEventRequest,
} from '@/src/types/Event';
import { User } from '@/src/types/User';

const IGNORE_PROPERTIES = [
  'challengeDescriptors',
  'collaborationOptions',
  'eventPermissions',
  'backupChallengeConfig',
  'test',
  'testCloneSuffix',
  'eventCode',
];

export const getEventDiffs = (
  oldEvent: EventBase,
  newEvent: JamEventRequest,
  user: User,
  eventConfig: EventConfiguration
) => {
  EventBase.setDefaults(user, oldEvent, eventConfig);
  JamEventRequest.setDefaults(user, newEvent, eventConfig);

  const propertiesToDiff: string[] = Object.keys(new JamEventRequest()).filter(
    (property) => !IGNORE_PROPERTIES.includes(property)
  );

  const changes: DiffChange[] = [
    ...diffObjects(oldEvent, newEvent, propertiesToDiff, EventBase.PROPERTY_LABEL_OVERRIDES),
    ...CollaborationOptions.diff(oldEvent.collaborationOptions, newEvent.collaborationOptions),
    ...getChallengesDiff(oldEvent.challengeDescriptors, newEvent.challengeDescriptors),
    ...EventPermission.diff(oldEvent.eventPermissions, newEvent.eventPermissions),
    ...BackupChallengeConfig.diff(
      oldEvent.backupChallengeConfig || new BackupChallengeConfig(),
      newEvent.backupChallengeConfig || new BackupChallengeConfig()
    ),
  ];

  if (newEvent.test !== oldEvent.test) {
    changes.push({
      property: 'Test Event',
      previousValue: oldEvent.test,
      updatedValue: newEvent.test,
    });
  }

  const TEST_ONLY = 'Test Event Only';
  const LIVE_AND_TEST = 'Live Event & Test Event';
  const LIVE_ONLY = 'Live Event Only';

  const previousTestValue = oldEvent.test ? TEST_ONLY : oldEvent.testCloneSuffix ? LIVE_AND_TEST : LIVE_ONLY;
  const updatedTestValue = newEvent.test ? TEST_ONLY : newEvent.testCloneSuffix ? LIVE_AND_TEST : LIVE_ONLY;

  if (previousTestValue !== updatedTestValue) {
    changes.push({
      property: 'Testing',
      previousValue: previousTestValue,
      updatedValue: updatedTestValue,
    });
  }

  return changes;
};
